import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { from, Subscription } from 'rxjs';
import { ReceivingLogStateService } from '../../../../domain/receiving-log/receiving-log-state.service';
import { ApiReceivingLogRow } from '../../../../models/logs/ApiReceivingLogRow';
import { ReceivingLogRow } from '../../../../models/logs/ReceivingLogRow';
import { AssetsDataService } from '../../../../service/assets-data.service';
import { PrintService } from '../../../../service/print.service';
import { NewLog } from '../../../../models/logs/NewLog';
import {
  ReceivingLogTableConfig,
  ReceivingLogTable,
  TableField,
} from '../../../../models/assets-data/receiving/ReceivingLogTableConfig.interface';
import { LogEntryPhoto } from '../../../../models/logs/photos/LogEntryPhoto.interface';
import { PhotoService } from '../../../../service/photo.service';
import { UiConfig } from '../../../../models/assets-data/UiConfig.interface';

interface LogDisplayField {
  label: string;
  value: string;
}

@Component({
  selector: 'app-preview-log-modal',
  templateUrl: './preview-log-modal.component.html',
  styleUrls: ['./preview-log-modal.component.css']
})
export class PreviewLogModalComponent implements OnInit, OnDestroy {
  @Input() includePhotosInEmail: boolean = true;
  @Input() isOpen: boolean = false;
  @Input() emailsDisabled: boolean = false;
  @Input() photosDisabled: boolean = false;
  @Input() printingChecked: boolean = false;
  @Input() logFormData: NewLog | null = null;
  @Output() togglePhotosInEmail = new EventEmitter<boolean>();
  @Output() toggleEmailsDisabled = new EventEmitter<boolean>();
  @Output() submitLog = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  logRowData: ReceivingLogRow | null = null;
  logEntryPhotos: LogEntryPhoto[] = [];
  isLoading: boolean = false;
  logDisplayFields: LogDisplayField[] = [];
  private logDataSubscription: Subscription | null = null;
  private loadingSubscription: Subscription | null = null;
  private logEntryPhotosSubscription: Subscription | null = null;
  labelMap: { [key: string]: string } = {};
  receivingLogTableData: ReceivingLogTable | null = null;
  previewIframes: { 
    dymo?: { content: string, styles: string }, 
    large?: { content: string, styles: string }, 
    dymoQty: number, 
    largeQty: number 
  } | null = null;


  constructor(
    private _receivingLogService:ReceivingLogStateService,
    private _assetsDataService: AssetsDataService,
    private _printService: PrintService,
    private _photoService: PhotoService
  ) {

  }

  ngOnInit(): void {
    this.logDataSubscription = this._receivingLogService.getDateFriendlyLogRowDataSubject().subscribe(data => {
      this.logRowData = data;
      this.updateLogDisplayFields();
    });

    this.logEntryPhotosSubscription = this._photoService.logEntryphotos$.subscribe(photos => {
      this.logEntryPhotos = photos;
    });

    this.loadingSubscription = this._receivingLogService.dataLoading.subscribe(loading => {
      this.isLoading = loading.isLoading;
    });

    const receivingLogTableData = this._assetsDataService.GetReceivingLogTableData();
    this.receivingLogTableData = receivingLogTableData;
    this.labelMap = receivingLogTableData.inputs.reduce((acc: { [key: string]: string }, field: TableField) => {
      acc[field.name] = field.label;
      return acc;
    }, {} as { [key: string]: string });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photosDisabled']) {
      this.photosDisabled = changes['photosDisabled'].currentValue;
    }
    // if (changes['logFormData'] ) {
    //   const logFormData = changes['logFormData'].currentValue;
    //   this.logFormData = logFormData;
    //   console.log('logFormData changed to:', logFormData);
    //   this.generatePreviews();
    // }
    // if (changes['printingChecked']) {
    //   this.printingChecked = changes['printingChecked'].currentValue;
    //   console.log('printingChecked changed to:', this.printingChecked);
    // }
  }

  ngOnDestroy(): void {
    if (this.logDataSubscription) {
      this.logDataSubscription.unsubscribe();
    }
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  // private generatePreviews(): void {
  //   if (this.logFormData) {
  //     this.previewIframes = this._printService.generatePreviews(this.logFormData);
  //   }
  // }

  private updateLogDisplayFields(): void {
    if (!this.logRowData || !this.receivingLogTableData) {
      this.logDisplayFields = [];
      return;
    }

    this.logDisplayFields = this.receivingLogTableData.inputs.map(field => ({
      label: field.label,
      value: (this.logRowData as any)[field.name]?.toString() || ''
    }));
  }

  onTogglePhotosInEmail(checked: boolean): void {
    this.togglePhotosInEmail.emit(checked);
    this.includePhotosInEmail = checked;
  }

  onToggleEmailsDisabled(event: any): void {
    this.toggleEmailsDisabled.emit(event);
    this.emailsDisabled = event.detail.checked;
  }

  onSubmit(): void {
    this.submitLog.emit();
  }

  onClose(): void {
    this.closeModal.emit();
  }
} 